export default "__VITE_ASSET__3KklAuCo__"